import '../scss/tariff-list.scss';

import '../common';